<script>
const createText = function(address) {
  if(! address) {
    return ''
  }
  const parts = []
  let append
  if(address.address) {
    parts.push(address.address)
    append = ', '
  }
  if(address.postalCode) {
    if(append) {
      parts.push(append)
    }
    parts.push(address.postalCode)
    append = ' '
  }
  if(address.city) {
    if(append) {
      parts.push(append)
    }
    parts.push(address.city)
    append = ' '
  }
  if(address.region) {
    if(append) {
      parts.push(append)
    }
    parts.push(address.region)
    append = ' '
  }
  if(address.country) {
    if(append) {
      parts.push(append)
    }
    parts.push(address.country)
  }
  return parts.join('')
}
export default {
  functional: true,
  props: {
    value: Object,
  },
  render (h, { props, data }) {
    return h('div', { class: data.staticClass }, createText(props.value))
  }
}
</script>
